import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	title: {
		id: 'polaris-components-quickstart.tasks.share-and-collaborate.title.non-final',
		defaultMessage: 'Share and collaborate',
		description: 'The title appears on the list of onboarding tasks in the sidebar',
	},
	description: {
		id: 'polaris-components-quickstart.tasks.share-and-collaborate.description.non-final',
		defaultMessage:
			'Share views to engage teams and stakeholders through real-time collaboration, voting, and comments.',
		description:
			'The description appears on the expanded task item of onboarding quickstart sidebar below the title',
	},
	roleRestrictionsText: {
		id: 'polaris-components-quickstart.tasks.share-and-collaborate.role-restrictions-text.non-final',
		defaultMessage: "Contributors can't publish views and invite users.",
		description: 'Text describing role restrictions',
	},
});
